module.exports = __webpack_public_path__ + "static/img/product.b08bbed.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/hardProduct/images/phone/product.png
// module id = avO2
// module chunks = 1